//  ------------------ URL Config -----------------------
// URL's related to Role Master
export const CREATE_ROLE = "/role/createRole"
export const UPDATE_ROLE = "/role/updateRole"
export const DELETE_ROLE = "/role/deleteRole"
export const GET_ALL_ROLE = "/role/getAllRole"
export const GET_ROLE_BY_ID = "/role/getRole"

// Get all responsibility
export const GET_ALL_RESPONSIBILITY = "/responsibilities/getAllResponsibilities"

// URL's related to Plant Master CRUD
export const CREATE_PLANT = "/branch/createBranch"
export const UPDATE_PLANT = "/branch/updateBranch"
export const GET_ALL_PLANT = "/branch/getAllBranches"
export const DELETE_PLANT = "/branch/deleteBranch"

// URL's related to User Master  CRUD
export const GET_USER_BY_ID = "/users/getUser/"
export const CREATE_USER = "/users/createUser"
export const UPDATE_USER = "/users/updateUser"
export const DELETE_USER = "/users/deleteUser"
export const GET_ALL_USER_BY_PLANT_ID = "/users/getAllUsers"
export const GET_ALL_USER_BY_PLANT_ID_WITHOUT_SUPER_ADMIN = "/users/getUsersByBranch"
export const GET_ALL_USER_BY_ACCOUNT_ID = "/users/getUserByAccount"

// URL's related Checklist Master CRUD
export const GET_ALL_ACTIVITY = "/activity/getAllActivities"
export const CREATE_ACTIVITY = "/activity/createActivity"
export const UPDATE_ACTIVITY = "/activity/updateActivity"
export const DELETE_ACTIVITY = "/activity/deleteActivity"
export const CREATE_BULK_CHECKLIST = "/checklist/createBulkChecklist"

// URL's related PPE Master CRUDs
export const GET_ALL_PPE = "/ppe/getAllPPE"
export const CREATE_PPE = "/ppe/createPPE"
export const UPDATE_PPE = "/ppe/updatePPE"
export const DELETE_PPE = "/ppe/deletePPE"

// URL's related Holiday Master CRUD
export const GET_All_HOLIDAYS = "/holidays/getAllHolidays"
export const GET_All_HOLIDAYS_BY_PLANT_ID = "/holidays/getPlantHolidays"
export const CREATE_HOLIDAY = "/holidays/createHoliday"
export const UPDATE_HOLIDAY = "/holidays/updateHoliday"
export const DELETE_HOLIDAY = "/holidays/deleteHoliday"
export const CREATE_BULK_HOLIDAY = "/holidays/createBulkHoliday"

// URL's related Loaction Master CRUD
export const GET_All_DEPARTMENT = "/department/getAllDepartments"
export const GET_All_DEPARTMENT_BY_PLANT_ID = "/department/getBranchDepartments"
export const CREATE_DEPARTMENT = "/department/createDepartment"
export const UPDATE_DEPARTMENT = "/department/updateDepartment"
export const DELETE_DEPARTMENT = "/department/deleteDepartment"

// URL's related to Area Master CRUD
export const GET_All_AREAS = "/area/getAllAreas"
export const GET_AREA_BY_BRANCH_AND_DEPT = "/area/getAreasByBranchAndDepartment"
export const CREATE_AREA = "/area/createArea"
export const UPDATE_AREA = "/area/updateArea"
export const DELETE_AREA = "/area/deleteArea"

// URL's related Contractor Master CRUD
export const GET_All_CONTRACTOR = "/contractor/getAllContractor"
export const GET_CONTRACTOR_BY_ID = "/contractor/getContractor"
export const CREATE_CONTRACTOR = "/contractor/createContractor"
export const UPDATE_CONTRACTOR = "/contractor/updateContractor"
export const DELETE_CONTRACTOR = "/contractor/deleteContractor"

// URL's related Labour Master CRUD
export const GET_All_LABOURS = "/labour/getAllLabour"
export const GET_ALL_LABOURS_BY_CONTRACTOR_ID = "/labour/getLabourByContractorId"
export const GET_LABOUR_BY_ID = "/labour/getLabour"
export const CREATE_LABOUR = "/labour/createLabour"
export const UPDATE_LABOUR = "/labour/updateLabour"
export const DELETE_LABOUR = "/labour/deleteLabour"

// URL's related to Work Type Master CRUD
export const GET_ALL_AUDIT_TYPE = "/auditType/getAllAuditType"
export const UPDATE_AUDIT_TYPE_WITH_BULK_ACTIVITIES = "/auditType/createAuditTypeBulkUpload"
export const CREATE_AUDIT_TYPE = "/auditType/createAuditType"
export const UPDATE_AUDIT_TYPE = "/auditType/updateAuditType"

// URL's related to audit Type category master CRUD
export const GET_ALL_AUDIT_TYPE_CATEGORY = "/auditTypeCategory/getAllAuditTypeCategory"
export const CREATE_AUDIT_TYPE_CATEGORY = "/auditTypeCategory/createAuditTypeCategory"
export const UPDATE_AUDIT_TYPE_CATEGORY = "/auditTypeCategory/updateAuditTypeCategory"
export const DELETE_AUDIT_TYPE_CATEGORY = "/auditTypeCategory/deleteAuditTypeCategory"

// -------------- URL's related to the Work Permit (Regular & Holiday) -------------------
// For Super-Admin
export const GET_ALL_WORK_PERMIT_BY_ITS_TYPE_AND_PLANT = "/workPermit/fetchWorkpermitByType/plant" // Not-Used
// For Normal User
export const GET_ALL_WORK_PERMIT_BY_ITS_TYPE_AND_PLANT_AND_USER = "/workPermit/fetchWorkpermitByUser/plant" // Not-Used
// To fetch all work permit by its status
export const GET_ALL_WORK_PERMIT_BY_ITS_STATUS = "/workPermit/fetchAllWorkPermitsByStatusDetails" // Currently in use

// Common For All
export const GET_ALL_WORK_PERMIT_BY_ITS_PLANT_AND_STATUS = "/workPermit/fetchAllWorkPermitsByStatus/plant"
export const GET_WORK_PERMIT_BY_ITS_ID = "/workPermit/fetchWorkPermitById"
export const CREATE_WORK_PERMIT = "/workPermit/createWorkPermit"
export const UPDATE_WORK_PERMIT = "/workPermit/updateWorkPermit"
// Approve or Reject work permit
export const APPROVE_OR_REJECT_WORK_PERMIT = "/workPermit/approveOrRejectWorkPermit"
// Suspend work permit
export const SUSPEND_WORK_PERMIT = "/workPermit/suspendWorkPermit"
// Review Work Permit
export const REVIEW_WORK_PERMIT = "/workPermit/reviewWorkPermit"
// Close Work Permit
export const CLOSE_WORK_PERMIT = "/workPermit/closeWorkPermit"
// Delete Work Permit
export const DELETE_WORK_PERMIT = "/workPermit/deleteWorkPermit"


// URL's related to audit master
export const GET_ALL_AUDITS = "/audit/getAuditsByBranchAndDepartment"
export const CREATE_AUDIT = "/audit/createAudit"
export const EDIT_AUDIT_FOR_ADMIN_SUPERADMIN = "/audit/editAudit"
export const AUDIT_REVIEW_BY_AUDITOR = "/audit/auditReviewByAuditor"
export const AUDIT_REVIEW_BY_AUDITEE = "/audit/auditReviewByAuditee"
export const CLOSE_AUDIT = "/audit/closeAudit"

// URL's related to the Work Permit Dashboard
export const GET_ALL_WORK_PERMIT_COUNT_BY_USER_ID = '/workPermit/fetchWorkPermitStatusCounts/plant'
export const GET_ALL_WORK_PERMIT_COUNT_BY_SUPER_ADMIN = '/workPermit/fetchWorkPermitStatusCountsByPlant/plant'
export const GET_ALL_WORK_PERMIT_COUNT_BY_ITS_TYPE = '/workPermit/fetchWorkPermitTypeCounts/plant'
export const GET_TOTAL_MODULES_COUNT_FOR_DASHBOARD = "/dashboard/getModulesCount"

// URL's Related to Company Details/Information
export const GET_COMPANY_DETAILS = "/company/getCompanyInformation"
export const UPDATE_COMPANY_DETAILS = "/company/updateCompanyInformation"

// URL's Related to Report Master
export const GET_WORK_PERMIT_REPORT = "/reports/workPermitReport"
export const GET_WORK_PERMIT_SUMMARY_REPORT = "/reports/summaryReport"

// URL's Related to Forgot Password
export const FORGOT_PASSWORD = "/auth/forgetPassword"


// URL's Related to Audit Report
export const GENERATE_AUDIT_REPORT = "/auditReport/getAuditReport"
// URL's Related to NC Report
export const GENERATE_NC_REPORT = "/auditReport/getNCReport"
// URL's Related to Third Party Audit Report
export const GENERATE_THIRD_PARTY_AUDIT_REPORT = "/auditReport/getThirdPartyAuditReport"

// URL's Related to Dashboard
export const DASHBOARD_DATA = "/dashboard/getDashboardCounts"


// --------------------- URLs Related to Third Party Audits ----------------------
export const GET_ALL_THIRD_PARTY_AUDITS = "/thirdPartyAudit/getAllThirdPartyAuditsByBranchAndDepartment";
export const CREATE_THIRD_PARTY_AUDIT = "/thirdPartyAudit/createThirdPartyAudit";
export const UPDATE_THIRD_PARTY_AUDIT = "/thirdPartyAudit/updateThirdPartyAudit";
export const UPDATE_STATUS_OF_THIRD_PARTY_AUDIT = "/thirdPartyAudit/updateStatusOfThirdPartyAudit";
export const DELETE_THIRD_PARTY_AUDIT = "/thirdPartyAudit/deleteThirdPartyAudit";



// --------------------------- Zingworks URL Endpoints ---------------------------
// URL's Related to Account Master
export const CREATE_NEW_COMPANY = "/accounts/createAccount";
export const UPDATE_COMPANY_INFORMATION = "/company/updateCompanyInformation"; // Not In use
export const GET_COMPANY_INFORMATION = "/accounts/getAllAccounts";
export const DELETE_COMPANY_ACCOUNT = "/accounts/deleteAccount";

// URL's Related to Assign Super-Admin Master
export const ASSIGN_ANOTHER_SUPER_ADMIN = "/users/assignZingworksSuperAdmin";
export const GET_ASSIGNED_SUPER_ADMIN = "/users/getZingworksSuperAdminAssignment";